module.exports = __webpack_public_path__ + "img/gallery6.19fc862.jpg";